import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-[#102C44] text-white py-12">
      <div className="container mx-auto grid md:grid-cols-3 gap-8 px-4">
        <div>
          <h3 className="text-2xl font-bold mb-4">Veltrah</h3>
          <p className="text-white/80">
            Enabling the Fifth Appendage.
          </p>
        </div>
        <div>
          <h4 className="text-xl font-semibold mb-4">Quick Links</h4>
          <ul className="space-y-2">
            <li><a href="#home" className="hover:text-[#36C9A2]">Home</a></li>
            <li><a href="#services" className="hover:text-[#36C9A2]">Products</a></li>
            <li><a href="#about" className="hover:text-[#36C9A2]">About</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xl font-semibold mb-4">Contact</h4>
          <p>Email: info@veltrah.com</p>
          <div className="flex space-x-4 mt-4">
            
            {/* links were removed here */}

          </div>
        </div>
      </div>
      <div className="text-center mt-8 border-t border-white/20 pt-4">
        © 2025 Veltrah. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;